import { useSelector } from 'react-redux';

import { ServiceOptionItem } from '../../../../ServiceSummary/types';
import { getFlight } from '../../../../Checkout/store/order/selectors';
import { InsuranceDirection, splitByDirection } from './splitByDirection';
import { groupByProduct } from './groupByProduct';
import { DirectionSegmentGroup } from '../model/types';

export interface InsuranceProductGroup {
	items: ServiceOptionItem[];
	directions: InsuranceDirection[];
}

export const useInsuranceGroups = (items: ServiceOptionItem[], activeGroupId?: string): InsuranceProductGroup[] => {
	const segmentGroups = (useSelector(getFlight)?.segmentGroups ?? []) as DirectionSegmentGroup[];

	const filteredSegmentGroups = activeGroupId
		? segmentGroups.filter(segmentGroup => segmentGroup.groupId === activeGroupId)
		: segmentGroups;

	return groupByProduct(items).map(productItems => ({
		items: productItems,
		directions: splitByDirection(productItems, filteredSegmentGroups)
	}));
};
